import { appConfig } from 'config/app';
import {
  ChannelType,
  IAccountRecovery,
  IAccountRecoveryResendCode,
  IAccountRecoveryVerification,
  ICreateAccountRecovery,
  ICreateAccountRecoveryIdentity,
  IIdentity,
  IVerifyAccountRecovery,
  IVerifyIdentity,
  IVerifyIdentityRequest,
} from 'types';
import { ApiClient } from './ApiClient';

export const AccountRecovery = {
  createAccountRecovery: (authId: string, body: ICreateAccountRecovery) => ApiClient.post<IAccountRecovery>(`${appConfig.API_BASE_URL}/v1/auth/${authId}/account_recovery`, body),
  verifyAccountRecovery: (acctRecoveryId: string, body: IVerifyAccountRecovery) => ApiClient.put<IAccountRecoveryVerification>(`${appConfig.API_BASE_URL}/v1/account_recovery/${acctRecoveryId}/verify`, body),
  resendAccountRecoveryCode: (acctRecoveryId: string) => ApiClient.put<IAccountRecoveryResendCode>(`${appConfig.API_BASE_URL}/v1/account_recovery/${acctRecoveryId}/resend`, {}),
  createIdentity: (acctRecoveryId: string, body: ICreateAccountRecoveryIdentity) => ApiClient.post<IIdentity>(`${appConfig.API_BASE_URL}/v1/account_recovery/${acctRecoveryId}/identity`, body),
  verifyIdentity: (acctRecoveryId: string, identityId: string, body: IVerifyIdentityRequest) => ApiClient.put<IVerifyIdentity>(`${appConfig.API_BASE_URL}/v1/account_recovery/${acctRecoveryId}/identity/${identityId}/verify`, body),
  resendVerificationCode: (acctRecoveryId: string, identityId: string, channel?: ChannelType.CALL) => ApiClient.put<IIdentity>(`${appConfig.API_BASE_URL}/v1/account_recovery/${acctRecoveryId}/identity/${identityId}/resend`, { channel }),
};
